import { observer } from 'mobx-react';
import { ORDER_HELP_FLOW_STEPS } from '@nandosaus/constants';
import { useEffect, useState } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { BackgroundFrame } from '../frames/background-frame';
import { Box, Col, Flex, Row } from '../grid';
import { GuestOrderHelpForm } from '../guest-order-help-form';
import { H2, P } from '../typography';
import { Icon } from '../icons';
import { Link } from '../link';
import { navigation } from '../../constants';
import { OrderHelp } from '../order-help';

const OrderHelpPageContent = observer(() => {
  const router = useRouter();
  const { OrderHelpStore, MemberStore } = useRootStore();
  const [isOnGuestDetailsForm, setIsOnGuestDetailsForm] = useState(true);

  useEffect(() => {
    if (MemberStore.isSignedIn) {
      router.push(navigation.ORDERS);
    }
  }, [MemberStore.isSignedIn, router]);

  return (
    <BackgroundFrame showFireIcon showTopBar={false}>
      <Flex alignItems="center" width="100%" flexDirection="column">
        <H2 pb={1}>Order help</H2>
        {isOnGuestDetailsForm ? (
          <Row alignItems="center">
            <P pr="0.25rem">Already have an account?</P>
            <Link as="p" href={navigation.SIGN_IN}>
              Sign in
            </Link>
          </Row>
        ) : null}

        <Row mt={2} p={2} bg="white" width={{ xs: 12 / 12, md: 10 / 12, lg: 6 / 12 }} minHeight="15rem">
          <Col width="100%" position="relative">
            {OrderHelpStore.currentStep !== ORDER_HELP_FLOW_STEPS.CONFIRMATION ? (
              <StyledButton
                title="Back"
                display="flex"
                alignItems="center"
                color="inherit"
                mb={1}
                onClick={() => {
                  if (isOnGuestDetailsForm) {
                    router.back();
                    return;
                  }

                  if (OrderHelpStore.currentStep === ORDER_HELP_FLOW_STEPS.SELECT_ISSUE) {
                    setIsOnGuestDetailsForm(true);
                    return;
                  }

                  OrderHelpStore.goBack();
                }}
              >
                <Icon name="chevron" height="24px" width="24px" rotate="90deg" />
                <P variant={3}>Back</P>
              </StyledButton>
            ) : null}
            {isOnGuestDetailsForm ? (
              <GuestOrderHelpForm
                onSubmit={values => {
                  setIsOnGuestDetailsForm(false);
                  OrderHelpStore.setGuestDetails(values);
                }}
              />
            ) : (
              <OrderHelp exitOrderHelp={() => router.back()} />
            )}
          </Col>
        </Row>
      </Flex>
    </BackgroundFrame>
  );
});

const StyledButton = styled(Box).attrs({ as: 'button', type: 'button' })`
  transition: opacity 200ms ease-in-out;
  &:hover {
    opacity: 0.75;
  }
`;

export { OrderHelpPageContent };
